var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5827 39.6C28.1293 39.6 26.7627 39.3 25.4827 38.7C24.216 38.1 23.1227 37.2667 22.2027 36.2C21.2827 35.1333 20.6227 33.8933 20.2227 32.48L25.4627 31.08C25.636 31.76 25.9427 32.3467 26.3827 32.84C26.836 33.3333 27.356 33.72 27.9427 34C28.5427 34.2667 29.156 34.4 29.7827 34.4C30.6093 34.4 31.3627 34.2 32.0427 33.8C32.736 33.4 33.2827 32.86 33.6827 32.18C34.096 31.5 34.3027 30.7467 34.3027 29.92C34.3027 29.0933 34.096 28.34 33.6827 27.66C33.2827 26.98 32.736 26.44 32.0427 26.04C31.3627 25.64 30.6093 25.44 29.7827 25.44C28.7693 25.44 27.9427 25.6133 27.3027 25.96C26.6627 26.2933 26.1827 26.6133 25.8627 26.92L21.2627 25.52L22.1427 10.2H37.8627V15.28H25.1427L27.0627 13.48L26.4627 23.36L25.5427 22.24C26.2627 21.6533 27.0827 21.2267 28.0027 20.96C28.9227 20.6933 29.7827 20.56 30.5827 20.56C32.396 20.56 33.9893 20.9667 35.3627 21.78C36.7493 22.58 37.8293 23.6867 38.6027 25.1C39.3893 26.5 39.7827 28.1067 39.7827 29.92C39.7827 31.7333 39.3093 33.3733 38.3627 34.84C37.416 36.2933 36.1693 37.4533 34.6227 38.32C33.076 39.1733 31.396 39.6 29.5827 39.6Z",
    fill: "#EB3000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 51.0059C25.5612 43.2841 14.25 46.3057 14.25 53.8932C14.25 62.4208 25.9908 65.4424 29.9282 73.3657L29.9998 73.5L30.0714 73.3657C34.0089 65.4424 45.7497 62.4208 45.7497 53.8932C45.8213 46.3057 34.4384 43.2841 29.9998 51.0059Z",
    fill: "#EB3000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5H);
export default __webpack_public_path__ + "static/media/5h.8cd3c88c4172973d01bb3398568d611b.svg";
export { ForwardRef as ReactComponent };